import React from "react";
import TableBase from "./Base";
import moment from "moment";

import { DATE_FORMAT_FRONTEND } from "../../constants";

const CompanyAdminsTable = ({ scrollHeight, actionWidth, withAction, ...props }) => {
  const COLUMNS = [
    {
      title: "Name",
      dataIndex: "name",
      width: 150,
      ellipsis: true,
    },
    {
      title: "Partner Name",
      dataIndex: "partnerNames",
      width: 150,
      ellipsis: true,
      render(value) {
        return Array.isArray(value) ? value.join(", ") : "";
      },
    },
    {
      title: "Companies Name",
      dataIndex: "companies",
      width: 150,
      ellipsis: true,
      render(_value, record) {
        return record.companies.map(c => c.company.name).join(", ");
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      width: 150,
      ellipsis: true,
      render(value) {
        return value ? moment(value).format(DATE_FORMAT_FRONTEND) : "-";
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      width: 150,
      ellipsis: true,
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: "action",
      width: actionWidth || 100,
      fixed: "right",
      render(record) {
        return withAction(record);
      },
    });
  }

  if (scrollHeight) {
    return <TableBase columns={COLUMNS} scroll={{ x: 991, y: scrollHeight }} {...props} />;
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default CompanyAdminsTable;
